// extracted by mini-css-extract-plugin
var _1 = "UpgradeDisclaimer_upgradeCartDisclaimer__hQJHR";
var _2 = "UpgradeDisclaimer_upgradeDisclaimerContainer__O3kBW";
export { _1 as "upgradeCartDisclaimer", _2 as "upgradeDisclaimerContainer" }
